import apiClient from './apiService';

export type ImpactSeverity = 'Low' | 'Medium' | 'High' | 'Critical';

export interface CapaImpact {
    id: number;
    entity_id: number;
    issue_id: number;
    investigation_id?: number | null;
    impact_category_id: number;
    impact_category_name?: string;
    impact_description?: string | null;
    impact_amount?: number | null;
    impact_severity: ImpactSeverity;
    vote_total?: number;
    user_voted?: boolean;
    is_active: number;
    is_approved: number;
    created_by?: number;
    created_on?: string;
}

export interface ImpactCreate {
    impact_category_id: number;
    impact_description?: string;
    impact_amount?: number | null;
    impact_severity: ImpactSeverity;
}

export interface ImpactUpdate {
    impact_category_id?: number;
    impact_description?: string;
    impact_amount?: number | null;
    impact_severity?: ImpactSeverity;
    is_active?: number;
}

export interface VoteResult {
    voted: boolean;
    total: number;
}

export const capaImpactsService = {
    list: async (investigationId: number): Promise<CapaImpact[]> => {
        const resp = await apiClient.get(`/api/v1/cap/investigations/${investigationId}/impacts`);
        return resp.data?.data ?? [];
    },
    create: async (investigationId: number, data: ImpactCreate): Promise<CapaImpact> => {
        const resp = await apiClient.post(`/api/v1/cap/investigations/${investigationId}/impacts`, data);
        return resp.data?.data;
    },
    update: async (investigationId: number, impactId: number, data: ImpactUpdate): Promise<void> => {
        await apiClient.put(`/api/v1/cap/investigations/${investigationId}/impacts/${impactId}`, data);
    },
    remove: async (investigationId: number, impactId: number): Promise<void> => {
        await apiClient.delete(`/api/v1/cap/investigations/${investigationId}/impacts/${impactId}`);
    },
    toggleVote: async (impactId: number): Promise<VoteResult> => {
        const resp = await apiClient.post(`/api/v1/cap/impacts/${impactId}/vote`);
        return resp.data?.data;
    },
};
